
import Vue from 'vue';
import { ObserveVisibility } from 'vue-observe-visibility';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { TextareaAutogrowDirective } from 'vue-textarea-autogrow-directive';
import Toasted from 'vue-toasted';
import { handleError } from '../../../../api';
import { Board, Card, Ticket } from '../../../backend/backendapi';
import { KanbanState } from '../../kanban.model';
import TextSuggest from '../../../textsuggest/TextSuggest';

Vue.use(Toasted, { duration: 2000 });

@Component({
  components: {
    TextSuggest,
  },
  directives: {
    'autogrow': TextareaAutogrowDirective,
    'observe-visibility': ObserveVisibility,
  },
})
export default class Description extends Vue {
  @Prop({ required: true })
  state!: KanbanState;
  @Prop({ required: true })
  board!: Board;
  @Prop({ required: true })
  flow!: Ticket;
  @Prop({ required: true })
  card!: Card;
  @Prop({ default: false })
  readonly!: boolean;
  @Prop({ default: false })
  lockeddown!: boolean;
  @Prop({ default: [] })
  userEmails!: string[];

  editDescription: string = '';

  mounted(): void {
    this.editDescription = this.card.description ?? '';
  }

  updateDescription(): void {
    if (this.readonly) {
      return;
    }

    const card = this.card.clone();
    card.description = this.editDescription;
    //save to backend
    this.state.cardsAPI.updateDescription(card)
        .then(res => {
          this.$toasted.info(this.$t('txtSaved').toString());
          this.card.description = card.description;
          this.card.updatedOnForReadConfirmation = res.result!.updatedOnForReadConfirmation;
        })
        .catch(e => handleError(this.$toasted, this.$i18n, e));
  }

  //desc box auto resize on modal open
  descBoxVisibilityCounter: number = 0;

  onDescBoxVisibilityChange(isVisible, entry): void {
    if (isVisible
        && this.descBoxVisibilityCounter < 2 //only allow first to changes, 2 is emperical
        && entry.target === this.$refs.descBox) {
      this.descBoxVisibilityCounter++;
      (this.$refs.descBox as HTMLTextAreaElement).dispatchEvent(new Event('change'));
    }
  }

  @Watch('card')
  onCardChange(): void {
    this.descBoxVisibilityCounter = 0;
  }

  @Watch('card', { deep: true })
  cardDescriptionListener(newCard: Card, oldCard: Card) {
    this.editDescription = newCard.description!;
  }
}

